module.exports = __webpack_public_path__ + "9d732d58b046ad2ba56d6f4e16c5450e.png";